import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="w-full bg-white py-10 md:py-20 px-6" data-id="element-389">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center" data-id="element-390">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-8" data-id="element-391">
          ¿Qué cambia en 7 días?
        </h2>
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-6" data-id="element-392">
          Pasás de vivir en alerta constante a entrar a tu living y sentir solo
          el olor a limpio de tu perfume de ambiente.
        </p>
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed" data-id="element-393">
          Tu gato deja de esconderse y vuelve a dormir con vos porque ya no
          siente la necesidad de "proteger" la cama con su orina.
        </p>
      </motion.div>
    </section>;
}